import { ExpandableDefaultSubmodelDisplay } from 'components/basics/ExpandableNestedContentWrapper';
import { Submodel } from 'api/v3/aas_core_meta/types';
import { TimeSeriesVisualizations } from './TimeSeriesVisualizations';

type TimeseriesDetailProps = {
    readonly submodel: Submodel;
};

export function TimeSeriesDetail(props: TimeseriesDetailProps) {
    return (
        <>
            <TimeSeriesVisualizations submodel={props.submodel} />
            <ExpandableDefaultSubmodelDisplay submodel={props.submodel} />
        </>
    );
}
